import { createSelector } from '@reduxjs/toolkit';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { ContactFormServerErrors, PartnerStorefrontState } from '../types';

export const selectContactFormServerErrors = createSelector(
  [(state: ReduxApplicationState) => state.partnerStorefront.error],
  (serverErrors: PartnerStorefrontState['error']): ContactFormServerErrors => ({
    email: serverErrors?.email?.join(', '),
    name: serverErrors?.name?.join(', '),
    message: serverErrors?.message?.join(', '),
  }),
);
